import { computed } from "mobx";
import { observer, inject } from "mobx-react";
import * as React from "react";
import * as Reader from "../DocumentReader";
import { FullScreen } from "../General/FullScreen";
import { Screenfull } from "../Screenfull";
import { AppStore } from "../Stores/AppStore";
import { DialogResult, DialogStore } from "../Stores/DialogStore";
import { NotificationStore } from "../Stores/NotificationStore";
import { Strings } from "../Stores/StringsStore";
import { Button } from "./Button";
import { IButtonProps } from "./IButtonProps";

interface IFeedbackButtonProps extends IButtonProps {
	fileName: string;
	fullScreen?: FullScreen;
}

@inject("fullScreen")
@observer
export class FeedbackButton extends React.Component<IFeedbackButtonProps, {}> {

	onClick = () => {
		if (this.props.fullScreen && Screenfull.element) {
			this.props.fullScreen.toggleFullScreen();
		}
		DialogStore.showFeedback(this.props.fileName).then(result => {
			if (result === DialogResult.Yes) {
				let feedback = new Reader.Feedback();
				feedback.subject = DialogStore.subject;
				feedback.message = DialogStore.message + "<br><br>" + window.location.href;
				Reader.sendFeedbackAsync(feedback)
					.then(sendFeedbackResult => {
						if (sendFeedbackResult.success) {
							NotificationStore.showSuccessMessage(sendFeedbackResult.message);
						}
						else {
							DialogStore.showError(Strings.general.errorDialogTitle, sendFeedbackResult.message);
						}
					})
					.catch(error => {
						DialogStore.showError(Strings.general.errorDialogTitle, Strings.reader.mailSendingError);
					});
			}
		});
	}

	@computed get isDisabled() {
		if (AppStore.context.sessionDetails.isAnonymous) {
			return true;
		}
		if (AppStore.context.sessionDetails.isApp) {
			return !AppStore.isSystemOnline;
		}
		return false;
	}

	render() {
		return <Button {...this.props} onClick={this.onClick} title={Strings.reader.sendFeedbackTitle} disabled={this.isDisabled}>
			<i>
				<svg id="Feedback" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 32 32">
					<g>
						<path fill="#010101" d="M32,2v16c0-0.5-0.05-0.94-0.14-1.31s-0.23-0.72-0.4-1.05s-0.38-0.63-0.63-0.94
							c-0.25-0.3-0.52-0.63-0.84-0.98V4H2v18h4v4.17L10.17,22h6.09c0.08,0.35,0.2,0.7,0.34,1.03s0.3,0.66,0.48,0.97H11l-7,7v-7H0V2H32z
							 M27.53,24.84c0.69,0.33,1.3,0.75,1.85,1.26s1.02,1.07,1.41,1.69s0.69,1.29,0.9,2C31.9,30.5,32,31.24,32,32h-2
							c0-0.82-0.16-1.6-0.48-2.33c-0.32-0.73-0.75-1.37-1.29-1.91c-0.54-0.54-1.18-0.97-1.91-1.29C25.6,26.16,24.82,26,24,26
							c-0.82,0-1.6,0.16-2.33,0.48c-0.73,0.32-1.37,0.75-1.91,1.29c-0.54,0.54-0.97,1.18-1.29,1.91C18.16,30.4,18,31.18,18,32h-2
							c0-0.76,0.1-1.5,0.31-2.21c0.21-0.71,0.51-1.38,0.9-2s0.86-1.18,1.41-1.69s1.16-0.92,1.85-1.26c-0.78-0.56-1.39-1.27-1.82-2.12
							C18.22,21.88,18,20.97,18,20c0-0.82,0.16-1.6,0.47-2.33s0.74-1.37,1.29-1.91s1.18-0.98,1.91-1.29C22.39,14.16,23.17,14,24,14
							c0.82,0,1.6,0.16,2.33,0.47c0.73,0.31,1.37,0.74,1.91,1.29s0.98,1.19,1.29,1.91S30,19.18,30,20c0,0.97-0.22,1.88-0.65,2.73
							C28.92,23.58,28.31,24.28,27.53,24.84z M24,24c0.55,0,1.07-0.1,1.55-0.31s0.91-0.49,1.27-0.86c0.36-0.37,0.65-0.79,0.86-1.27
							C27.9,21.07,28,20.55,28,20s-0.1-1.07-0.31-1.55c-0.21-0.48-0.5-0.91-0.86-1.27c-0.37-0.37-0.79-0.65-1.27-0.86S24.55,16,24,16
							c-0.55,0-1.07,0.1-1.55,0.31s-0.91,0.49-1.27,0.86c-0.37,0.37-0.65,0.79-0.86,1.27C20.1,18.93,20,19.45,20,20s0.1,1.07,0.31,1.55
							c0.21,0.48,0.49,0.91,0.86,1.27c0.36,0.37,0.79,0.65,1.27,0.86S23.45,24,24,24z"/>
					</g>
				</svg>
			</i>
		</Button>;
	}
}